var fn = function( obj ){
var __t,__p='';
__p+='precision highp float;\n\n#if __VERSION__ == 300\n  #define IN in\n  #define OUT out\n#else\n  #define IN attribute\n  #define OUT varying\n#endif\n\n\nIN vec2 aTexCoord0;\n\nOUT vec2 vTexCoordVP;\nOUT vec2 vTexCoordFull;\n\nuniform vec2 uViewportScale;\n\nvoid main(void)\n{\n  vTexCoordVP   = aTexCoord0 * uViewportScale;\n  vTexCoordFull = aTexCoord0;\n\n  gl_Position.xy = 2.0 * aTexCoord0-vec2(1.0,1.0);\n  gl_Position.zw = vec2(0.0,1.0);\n}\n';
return __p;
};
fn.toString=fn;
export default fn;
fn._hmrListeners = []
fn.onHmr = function(l){
  this._hmrListeners.push( l )
}
fn._triggerHmr = function(){
  for (const l of this._hmrListeners) {
    l( this )
  }
}

if( import.meta.hot ){
  if( import.meta.hot.data && import.meta.hot.data._hmrListeners ){
    fn._hmrListeners = import.meta.hot.data._hmrListeners;
    fn._triggerHmr()
  }
  
  import.meta.hot.dispose(data => {
    data._hmrListeners = fn._hmrListeners;
  });
  
  import.meta.hot.accept(
    function(e){} // Function to handle errors when evaluating the new version
  );
}
